import { c as _c } from "react/compiler-runtime";
import { Download, Plus, Upload } from 'lucide-react';
import { useNewProfileDialog } from '@/contexts/new-profile-dialog-context';
import { useExportBackupFile } from '@/hooks/backup/use-export-backup-file';
import { useImportBackupFile } from '@/hooks/backup/use-import-backup-file';
import { useTranslation } from '@/hooks/use-translation';
const itemClassName = 'flex min-h-10 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none short:min-h-8';

/** What can be done with the profile as a file: start one, save it, load one. */
export const SidebarFileGroup = () => {
  const $ = _c(32);
  const {
    t
  } = useTranslation();
  const {
    exportBackupFile
  } = useExportBackupFile();
  const {
    inputRef,
    onInputFileChange,
    triggerImport
  } = useImportBackupFile();
  const {
    openNewProfileDialog
  } = useNewProfileDialog();
  let t0;
  if ($[0] !== t) {
    t0 = t("New Profile", {
      ns: "navigation"
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== openNewProfileDialog || $[3] !== t0) {
    t1 = {
      icon: Plus,
      label: t0,
      onClick: openNewProfileDialog
    };
    $[2] = openNewProfileDialog;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("Export", {
      ns: "navigation"
    });
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== exportBackupFile || $[8] !== t2) {
    t3 = {
      icon: Download,
      label: t2,
      onClick: exportBackupFile
    };
    $[7] = exportBackupFile;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("Import", {
      ns: "navigation"
    });
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4 || $[13] !== triggerImport) {
    t5 = {
      icon: Upload,
      label: t4,
      onClick: triggerImport
    };
    $[12] = t4;
    $[13] = triggerImport;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5) {
    t6 = [t1, t3, t5];
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const actions = t6;
  let t7;
  if ($[19] !== t) {
    t7 = t("File", {
      ns: "navigation"
    });
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <span className="ptl-label px-2.5 pb-1.5">{t7}</span>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== actions) {
    t9 = actions.map(_temp);
    $[23] = actions;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== inputRef || $[26] !== onInputFileChange) {
    t10 = <input ref={inputRef} type="file" accept="application/json" className="hidden" onChange={onInputFileChange} />;
    $[25] = inputRef;
    $[26] = onInputFileChange;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
    t11 = <div className="flex flex-col gap-0.5">{t8}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
function _temp(action) {
  return <button key={action.label} type="button" className={itemClassName} onClick={action.onClick}><action.icon className="size-[17px]" />{action.label}</button>;
}